import { render } from "./Wireguard.vue?vue&type=template&id=6df87098"
import script from "./Wireguard.vue?vue&type=script&lang=js"
export * from "./Wireguard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__